/**
 * Facts about the venue share link that both sides have to agree on.
 *
 * See `docs/public-schedule.md`.
 */

/**
 * What a share token starts with.
 *
 * The API mints it; the web redacts it before anything is logged. Two copies of
 * this string would mean a breadcrumb quietly carrying a live link the day
 * somebody changed one of them.
 */
export const SHARE_TOKEN_PREFIX = 'sched_'

/**
 * How long a phase's setup instructions may be.
 *
 * Shared so the box a person types into and the schema that accepts it cannot
 * disagree — the failure otherwise is a save that is refused with no way for the
 * writer to see why.
 */
export const SETUP_INSTRUCTIONS_MAX = 5000
